import api from 'services/api';
import get from 'lodash/get';
import {
  SCHEDULE_FETCHING,
  SCHEDULE_TABLE_SELECT_ROW,
  SCHEDULE_FAIL,
  RUN_SCHEDULE,
  SCHEDULED_AGENTS_GET_DATA,
  SCHEDULE_SET_IS_CREATE,
  SCHEDULER_UNSELECTED,
  SCHEDULER_SELECTED,
  SCHEDULER_NEW_PIVOT,
  UNSELECT_ALL_SCHEDULER,
  SELECT_ALL_SCHEDULER,
  SCHEDULE_SET_SECTION,
  SCHEDULER_CLEAR_ERROR,
  GET_SCHEDULERS_COUNT_SUCCESS,
  SCHEDULE_RESET_STATE,
  GET_USER_AGENTS_FOR_SCHEDULER,
  SCHEDULER_DETAIL,
  SCHEDULER_RESET_DETAIL
} from './constants';
import {
  selectData,
  selectIsFetching,
  selectLastSelected,
  selectSchedulersSelected,
  selectSchedulersTotal,
  selectSelectedSection
} from './selectors';
import { setFiedsError } from 'Screens/Contextualization/ManageEditCreate/actions/Actions';
import { selectAdvancedFilterQueryParam, selectQueryParam, selectRowsPerPage } from 'store/Filters/selectors';
import { setOrderBy, setPageNumber } from 'store/Filters/actions';

export const resetState = () => (dispatch) => dispatch({ type: SCHEDULE_RESET_STATE });

export function fetching (section) {
  return async (dispatch, getState) => {
    const isFetching = selectIsFetching(getState(), section);
    if (!isFetching) dispatch({ type: SCHEDULE_FETCHING, isFetching: true, section });
  };
}

export function somethingWentWrong (message) {
  return async (dispatch, getState) => {
    const section = selectSelectedSection(getState());
    dispatch({ type: SCHEDULE_FAIL, message, section });
  };
}

export function selectScheduleRow (rowSelectedInfo) {
  return async (dispatch) => {
    dispatch({ type: SCHEDULE_TABLE_SELECT_ROW, rowSelectedInfo });
  };
}

export function getSchedules () {
  return async (dispatch, getState) => {
    const section = 'scheduledAgents';
    try {
      dispatch(fetching(section));
      let advancedFilterQueryParam = [];

      try {
        advancedFilterQueryParam = selectAdvancedFilterQueryParam(getState(), 'scheduler');
      } catch (e) {
        dispatch(setFiedsError('scheduler', 'Syntax error. Please try again. For further help check our documentation'));
      }
      const hasAdvancedFilter = advancedFilterQueryParam.filters.length > 0;
      const standardQueryParam = selectQueryParam('scheduler', getState());
      const queryParam = hasAdvancedFilter ? advancedFilterQueryParam : standardQueryParam;

      const schedulers = await api.schedule.fetchSchedules(queryParam);
      dispatch({ type: SCHEDULED_AGENTS_GET_DATA, data: schedulers?.rows, total: schedulers?.total_rows });
    } catch (e) {
      dispatch(somethingWentWrong(get(e, 'message', 'There was an error, please try again')));
    }
  };
}

export const getCountSchedulers = () => async (dispatch) => {
  try {
    const response = await api.schedule.fetchCountSchedulers();
    dispatch({ type: GET_SCHEDULERS_COUNT_SUCCESS, response });
  } catch (e) {
    dispatch(somethingWentWrong(get(e, 'message', 'There was an error, please try again')));
  }
};

export function sortBySchedulers (orderBy) {
  return async (dispatch, getState) => {
    const section = selectSelectedSection(getState());
    const entity = section === 'scheduledAgents' ? 'scheduler' : 'cloudScheduler';
    dispatch(setOrderBy(entity, orderBy));
    dispatch(getSchedules());
  };
}

export function setPage (page, section) {
  return async (dispatch) => {
    const entity = section === 'scheduledAgents' ? 'scheduler' : 'cloudScheduler';
    dispatch(setPageNumber(entity, page));
    dispatch(getSchedules());
  };
}

export const setIsCreateSchedule = (value) => (dispatch) => {
  dispatch({ type: SCHEDULE_SET_IS_CREATE, value });
};

const addDeleteController = (schedulers, schedulersList) => {
  const allSchedulersAreSelected = schedulers.every(testScheduler => schedulersList.some((scheduler) => scheduler.value.id === testScheduler.value.id));

  if (allSchedulersAreSelected) return [SCHEDULER_UNSELECTED, schedulers];
  return [SCHEDULER_SELECTED, schedulers];
};

const selectCalculator = (e, scheduler, schedulersList, areSchedulerSelected) => (dispatch, getState) => {
  const pivot = selectLastSelected(getState());
  const index = schedulersList.findIndex((el) => el.value.id === scheduler.value.id);
  const schedulersSelected = selectSchedulersSelected(getState());

  dispatch({ type: SCHEDULER_NEW_PIVOT, payload: index });
  if (e.shiftKey && pivot !== -1 && areSchedulerSelected) {
    const start = Math.min(pivot, index);
    const end = Math.max(pivot, index) + 1;
    const schedulers = schedulersList.slice(start, end);
    const [type, payload] = addDeleteController(schedulers, schedulersSelected);
    return dispatch({ type, payload });
  }
  const [type, payload] = addDeleteController([scheduler], schedulersSelected);
  return dispatch({ type, payload });
};

export const selectRow = (e, scheduler) => (dispatch, getState) => {
  const section = selectSelectedSection(getState());
  const allSchedulers = selectData(getState(), section);
  const schedulerSelected = selectSchedulersSelected(getState());
  dispatch(selectCalculator(e, scheduler, allSchedulers, schedulerSelected.length > 0));
};

export const unSelectAll = () => (dispatch) => dispatch({ type: UNSELECT_ALL_SCHEDULER });

export const selectAllScheduler = () => (dispatch, getState) => {
  const section = selectSelectedSection(getState());
  const entity = section === 'scheduledAgents' ? 'scheduler' : 'cloudScheduler';
  const schedulersList = selectData(getState(), section);
  const schedulersSelected = selectSchedulersSelected(getState());
  const schedulerCount = selectSchedulersTotal(getState(), section);
  const pageSize = selectRowsPerPage(entity, getState());

  if (schedulersSelected.length === schedulerCount || schedulersSelected.length >= pageSize) return dispatch(unSelectAll());

  return dispatch({ type: SELECT_ALL_SCHEDULER, schedulersList });
};

export const selectScheduler = (scheduler) => (dispatch) => {
  dispatch({ type: SCHEDULER_SELECTED, payload: [scheduler] });
};

export const setSection = (section) => (dispatch) => {
  dispatch({ type: SCHEDULE_SET_SECTION, section });
  dispatch(unSelectAll());
};

export function removeSchedule () {
  return async (dispatch, getState) => {
    try {
      dispatch(fetching());
      const schedulersSelected = selectSchedulersSelected(getState());

      await Promise.all(schedulersSelected.map(async (row) => {
        await api.schedule.removeSchedule(row.id);
      }));
      dispatch(unSelectAll());
      dispatch(getSchedules());
      dispatch(getCountSchedulers());
    } catch (e) {
      dispatch(somethingWentWrong(get(e, 'message', 'There was an error, please try again')));
    }
  };
}

export function saveSchedule (scheduleId, agentId, crontabName, active, crontab, description, executorId, parameters, workspaces, timezone) {
  return async (dispatch) => {
    try {
      dispatch(fetching());

      if (scheduleId === 0) {
        await api.schedule.createSchedule(agentId, crontabName, active, crontab, description, executorId, parameters, workspaces, timezone);
      } else {
        await api.schedule.updateSchedule(scheduleId, agentId, crontabName, active, crontab, description, executorId, parameters, workspaces, timezone);
      }
      dispatch(unSelectAll());
      dispatch(getSchedules());
      dispatch(getCountSchedulers());
    } catch (e) {
      dispatch(somethingWentWrong(get(e, 'message', 'There was an error, please try again')));
    }
  };
}

export function changeStatus (scheduleId, status) {
  return async (dispatch) => {
    try {
      dispatch(fetching());
      await api.schedule.changeStatus(scheduleId, status);
      dispatch(getSchedules());
    } catch (e) {
      dispatch(somethingWentWrong(get(e, 'message', 'There was an error, please try again')));
    }
  };
}

export function runSchedule (id) {
  return async (dispatch) => {
    try {
      await api.schedule.runSchedule(id);
      dispatch({ type: RUN_SCHEDULE, id });
    } catch (e) {
      dispatch(somethingWentWrong(get(e, 'message', 'There was an error, please try again')));
    }
  };
}

export function clearError (section) {
  return async (dispatch) => {
    dispatch({ type: SCHEDULER_CLEAR_ERROR, section });
  };
}

export function getAllUserAgents () {
  return async (dispatch) => {
    try {
      const userAgents = await api.agents.fetchAllUserAgents();
      dispatch({ type: GET_USER_AGENTS_FOR_SCHEDULER, userAgents: get(userAgents, 'rows', []) });
    } catch (e) {
      dispatch(somethingWentWrong(get(e, 'message', 'There was an error, please try again')));
    }
  };
}

export const setSchedulerDetail = (scheduler) => (dispatch) => {
  dispatch({ type: SCHEDULER_DETAIL, scheduler });
};

export const resetDetail = () => (dispatch) => {
  dispatch({ type: SCHEDULER_RESET_DETAIL });
};
